import { FC } from "react";
import { createDataKey, extractDataId } from "utils/dataKey";
import { useQueryUseCaseData } from "./topics/calculate/calculationHooks";

interface UploadedDataNameProps {
  solutionKey: string;
  useCaseKey: string;
  useCaseVersion: string | null;
  dataId?: string;
}

const UploadedDataName: FC<UploadedDataNameProps> = ({
  solutionKey,
  useCaseKey,
  useCaseVersion = null,
  dataId
}) => {
  const dataKey = createDataKey({
    solutionKey,
    useCaseKey,
    version: useCaseVersion,
    dataId
  });

  const { data: useCaseData } = useQueryUseCaseData({
    solutionKey,
    useCaseKey,
    useCaseVersion,
    skipUntilAddress: null,
    limit: null,
    keys: dataKey ? [dataKey] : []
  });

  const currentData =
    useCaseData?.solutions.solution?.useCases?.useCase?.data.filter(
      d => extractDataId(d.detail?.key) === dataId
    )[0];

  return <div>{currentData?.detail?.metaData.displayName}</div>;
};

export default UploadedDataName;
